module.exports = __webpack_public_path__ + "static/media/CAM-02-mobile.234f185e.webp";